import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Flex, TagsTextArea } from 'ui';
import cloneDeep from 'lodash.clonedeep';
import {
  StyledLabel,
  TextAreaWrapper,
  StyledDropdown,
  StyledTranslateButton,
} from './original-section';

const TranslatedSection = ({
  intl,
  isLoading,
  locale,
  translatorLanguages,
  setTranslatedTextValue,
  translatedTextValue,
  fetchTranslatedText,
  translateFromLanguage,
  originalTextValue,
  translatedText,
  tags,
}) => {
  const [translateToLanguage, setTranslateToLanguage] = useState();
  const [supportedLanguages, setSupportedLanguages] = useState([]);

  useEffect(() => {
    setTranslatedTextValue(translatedText);
  }, [translatedText]);

  useEffect(() => {
    if (translatorLanguages?.length) {
      setSupportedLanguages(cloneDeep(translatorLanguages));
    }
  }, [translatorLanguages]);

  useEffect(() => {
    if (supportedLanguages?.length) {
      const defaultLanguage = supportedLanguages?.find(l => l.key === locale) ||
        supportedLanguages?.find(l => l.key === locale.split('-')[0]) ||
        supportedLanguages?.find(l => l.key === 'en');

      defaultLanguage.name =
        `${defaultLanguage.name} (${intl.formatMessage({ id: 'translation.DEFAULT' })})`;
      setTranslateToLanguage(defaultLanguage.key);
    }
  }, [supportedLanguages]);

  const translateText = () => {
    fetchTranslatedText({
      from: translateFromLanguage,
      to: translateToLanguage,
      text: originalTextValue,
    });
  };

  return (
    <>
      <StyledLabel>
        {intl.formatMessage({ id: 'translation.TRANSLATED_TEXT' })}
      </StyledLabel>
      <TextAreaWrapper>
        <TagsTextArea
          height='150px'
          tags={tags}
          value={translatedTextValue}
          disabled={true}
        />
      </TextAreaWrapper>
      <StyledLabel>
        {intl.formatMessage({ id: 'translation.TRANSLATE_TO' })}
      </StyledLabel>
      <Flex jcsb>
        <StyledDropdown
          placeholder={'language'}
          values={supportedLanguages}
          valueKey='key'
          valueLabel='name'
          disabled={isLoading}
          value={translateToLanguage}
          onChange={e => setTranslateToLanguage(e)}
        />
        <StyledTranslateButton
          onClick={translateText}
          disabled={isLoading || !originalTextValue}
          type='secondary'
        >
          {intl.formatMessage({ id: 'translation.TRANSLATE' })}
        </StyledTranslateButton>
      </Flex>
    </>
  );
};

TranslatedSection.propTypes = {
  intl: PropTypes.object,
  isLoading: PropTypes.bool,
  translatorLanguages: PropTypes.array,
  translateFromLanguage: PropTypes.string,
  locale: PropTypes.string,
  setTranslatedTextValue: PropTypes.func,
  translatedTextValue: PropTypes.string,
  fetchTranslatedText: PropTypes.func,
  translatedText: PropTypes.string,
  originalTextValue: PropTypes.string,
  tags: PropTypes.array,
};

export default injectIntl(TranslatedSection);
